import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MenuAppBar from './modules/MenuAppBar/MenuAppBar';
import Footer from './modules/Footer/Footer';
import Flyer from './modules/Flyer/Flyer';
import EntryForm from './modules/EntryForm/EntryForm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
				<React.StrictMode>
					<Box sx={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
						<CssBaseline/>
						<MenuAppBar/>
						<Grid container component="main" sx={{mt: 1, mb: 1}}>
							<Grid item xs={false} sm={4} 
							sx={{display: 'flex',	justifyContent: 'center',
							alignItems: 'center'}}>
								<Flyer name="https://ocastor.go78.org/images/Flyer_2.jpg"/>
							</Grid>
							<Grid item px={1} xs={12} sm={8} >
								<EntryForm/>
							</Grid>
						</Grid>
						<Footer/>
					</Box>
				</React.StrictMode>
				);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
